<div *ngIf="this.route !== '' then withroute else withoutroute"></div>
<ng-template #withroute>
    <a [ngClass]="class" [routerLink]="route" [state]="modelState"><i [ngClass]="icon"></i>{{text}} </a>
</ng-template>
<ng-template #withoutroute>
    <a [ngClass]="class"><i [ngClass]="icon"></i>{{text}} </a>
</ng-template>
